
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patient-services",
      function () {
        return require("private-next-pages/patient-services/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patient-services"])
      });
    }
  